import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "../api";
import { applyMeta, setFavicon } from "../lib/meta";

function applyDesign(data) {
  const root = document.documentElement;
  if (data.primary_color) root.style.setProperty("--gp-navy", data.primary_color);
  if (data.accent_color) {
    root.style.setProperty("--gp-teal", data.accent_color);
    root.style.setProperty("--gp-teal-dark", data.accent_color);
  }
  if (data.background_image) {
    document.body.style.backgroundImage = `url("${data.background_image}")`;
    document.body.style.backgroundSize = "cover";
    document.body.style.backgroundPosition = "center";
    document.body.style.backgroundAttachment = "fixed";
  } else {
    document.body.style.backgroundImage = "";
  }
}

// Applies the super-admin editable global title/meta/favicon, OG image AND design tokens.
// Store/voucher pages set their own per-page meta, so we skip those routes for meta only.
export default function SiteMeta() {
  const location = useLocation();

  useEffect(() => {
    api
      .get("/site-content")
      .then(({ data }) => {
        applyDesign(data);
        if (data?.favicon) setFavicon(data.favicon);
        const isPerPage = /^\/store\//.test(location.pathname) || /^\/events\/category\//.test(location.pathname) || /^\/events\/city\//.test(location.pathname);
        if (!isPerPage) {
          applyMeta({
            title: data?.meta_title,
            description: data?.meta_description,
            image: data?.og_image,
          });
        }
      })
      .catch(() => {});
  }, [location.pathname]);

  return null;
}
